import { theme as chakraTheme } from '@chakra-ui/react';
import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react';
import { createBreakpoints } from '@chakra-ui/theme-tools';

const COLORS = {
  primary: "#212429",
  secondary: "#bae408",
  dark: "#6e7681",
  light: "#e9f0f7",
  background: "#e9f0f7",
  secondaryLight: "#dcf183",
  primaryText: "#e0e0e0",
  input: "#8993a1",
}

const overrides = {
  ...chakraTheme,
  colors: {
    ...COLORS,
  },
  components: {
    Button: {
      baseStyle: {
        _hover: {
          boxShadow: 'none',
        },
        _focus: {
          transition: 'box-shadow 0.15s',
        },
      },
      variants: {
        link: {
          padding: '2px',
        },
      },
    },
    Tabs: {
      parts: ['tab'],
      baseStyle: {
        tab: {
          _focus: {
            boxShadow: 'none',
          },
        },
      },
    },
    Input: {
      parts: ["field"],
      variants: {
        outline: {
          field: {
            bg: "white",
            borderColor: COLORS.input,
            _hover: {
              borderColor: "dark"
            }
          }
        },
      },
    },
    Checkbox: {
      baseStyle: {
        control: {
          bg: "white",
          borderColor: COLORS.input
        }
      },
      defaultProps: {
        colorScheme: "green",
      },
    },
  },
};

const theme = extendTheme(
  overrides,
  withDefaultColorScheme({ colorScheme: 'gray' })
);

export default theme;
